import store from "../../store";

const host_organization = process.env.VUE_APP_API_HOST + process.env.VUE_APP_ORGANIZATION_PREFIX;
const organization = String(process.env.VUE_APP_ORGANIZATION_PREFIX).replace('/', '');

export default {
  ORGANIZATION_URLS: host_organization + 'organization/',
  ORGANIZATION_TREE_URLS: host_organization + 'department/tree/',
  DEPARTMENT_SELECTOR: host_organization + 'selectors/organization/1/department/',
  POSITION_SELECTOR: host_organization + 'selectors/position/',
  WORKER_IAM: host_organization + 'worker/iam/',
  WORKER_IN_DEPARTMENTS: host_organization + 'worker/?positionheld__department__id__in=',

  getUrl(urlname, action) {
    let url = store.getters['urls/getPattern'](
      organization,
      urlname,
      action
    );
    if (url !== '')
      return process.env.VUE_APP_API_HOST + process.env.VUE_APP_ORGANIZATION_PREFIX.replace('/', '') + url;
    else
      return ''

  },
  getStore(){
    return store
  },
  getUrlAllowed(urlname, action) {
    return store.getters['urls/getAllowed'](
      organization,
      urlname,
      action
    );
  },


  CHOICES_ORGANIZATION: {
    BASE: host_organization + 'choices/',
    POSITIONHELD_TYPE: 'positionheld/type/',
    getUrl: function (urlname) {
      return this.BASE + this[urlname];
    }
  },
  WORKER_URLS: {
    BASE: host_organization + 'profile/',
    WORKER: {
      SELF: 'worker/',
      UPDATE: 'worker/<id>/',
      CREATE: 'worker/',
      ISWORKER: 'worker/exist/',
    },

    POSITIONHELDS: {
      LIST: 'positionheld/',
      CREATE: 'positionheld/',
      UPDATE: 'positionheld/<id>/',
      DELETE: 'positionheld/<id>/',
    },
    getNamedUrl: function (namespace, urlname) {
      return this.BASE + this[namespace][urlname]
    },
    getUrl: function (urlname) {
      return this.BASE + this[urlname];
    }
  },

}
